<template>
  <div class="code">
    <div class="code__desc">
      <div class="form__success" v-if="success">{{ success }}</div>
      <p>Proszę podać adres e-mail, na który zostanie wysłany link do resetu hasła:</p>
    </div>
    <div class="code__form">
      <div class="code__section">
        <div class="form__row code__row">
          <img src="@/assets/svg/lock.svg" alt />
          <input
            type="text"
            class="code__input"
            @blur="checkEmail"
            @keydown.enter="handleSubmit"
            v-model="email"
            placeholder="Adres e-mail*"
          />
          <div v-if="error" class="form__row-error form__row-error--icon">{{error}}</div>
        </div>
        <div class="form__row code__row">
          <a @click="handleSubmit" :class="submitBtnClass">Wyślij e-mail z linkiem</a>
        </div>
      </div>
      <div class="code-actions">
        Jeśli wiadomość nie dotarła prosimy o kontakt z nami.
        <br />
        <router-link to="/kontakt" class="btn">Kontakt</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "ResetPasswordRequest",
  data() {
    return {
      submitBtnClass: "btn",
      error: "",
      success: "",
      email: ""
    };
  },
  computed: mapGetters({
    registrationData: "getRegistrationData"
  }),
  methods: {
    checkEmail() {
      this.error = "";
      !this.email
        ? (this.error = "Email jest wymagany")
        : !this.validEmail(this.email)
        ? (this.error = "Podaj prawidłowy adres e-mail")
        : "";
    },
    validEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    handleSubmit(e) {
      e.preventDefault();

      this.checkEmail();

      if (this.email && !this.error) {
        this.submitBtnClass = "btn spinner spinner--running";
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URL}/account/password-reset`,
          data: {
            email: this.email
          }
        })
        .then(() => {
          this.submitBtnClass = "btn spinner spinner--complete";
          this.success = "Wiadomość została wysłana!";
          setTimeout(() => this.$router.push("/"), 10000);
        })
        .catch(err => {
          this.submitBtnClass = "btn";
          this.error = err.response.data.message
            ? err.response.data.message
            : "Wystąpił nieznany błąd";
        });
      }
    }
  }
};
</script>

<style lang="scss" >
</style>
